import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

type Item = {
  label: string;
  to?: string;
  comingSoon?: boolean;
};

type Group = {
  title: string;
  items: Item[];
};

const GROUPS: Group[] = [
  {
    title: 'Today',
    items: [
      { label: 'Dashboard', to: '/app' },
      { label: 'Inbox', comingSoon: true },
      { label: 'My Tasks', to: '/tasks' },
    ],
  },
  {
    title: 'Recruiting',
    items: [
      { label: 'Pipeline', to: '/recruiting/pipeline' },
      { label: 'Recruits', to: '/recruiting/recruits' },
      { label: 'Applications', to: '/recruiting/applications/new' },
      { label: 'Apply Links', to: '/recruiting/links' },
      { label: 'Interviews', to: '/calendar' },
    ],
  },
  {
    title: 'Onboarding',
    items: [
      { label: 'Contracts', comingSoon: true },
      { label: 'Training', comingSoon: true },
      { label: 'Licensing', comingSoon: true },
      { label: 'Ready-to-Sell', comingSoon: true },
    ],
  },
  {
    title: 'Automations',
    items: [
      { label: 'Workflows', comingSoon: true },
      { label: 'Sequences', comingSoon: true },
      { label: 'Templates', comingSoon: true },
      { label: 'Forms', comingSoon: true },
    ],
  },
  {
    title: 'Growth',
    items: [
      { label: 'Reports', comingSoon: true },
      { label: 'Sources', comingSoon: true },
      { label: 'Leaderboard', comingSoon: true },
    ],
  },
  {
    title: 'Operations',
    items: [
      { label: 'Team & Roles', comingSoon: true },
      { label: 'Settings', comingSoon: true },
      { label: 'Billing', to: '/account/billing' },
      { label: 'Integrations', comingSoon: true },
      { label: 'Audit Log', comingSoon: true },
    ],
  },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="w-60 shrink-0 border-r border-dg-border bg-dg-navy/80 px-4 py-6 overflow-y-auto"
    >
      <div className="px-2 mb-6">
        <div className="h-display text-dg-red text-2xl">DAL</div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-dg-mist mt-0.5">
          Disruption Group
        </div>
      </div>

      <nav className="space-y-6">
        {GROUPS.map((g) => (
          <div key={g.title} data-testid={`sidebar-group-${g.title.toLowerCase()}`}>
            <div className="px-2 text-[11px] uppercase tracking-[0.18em] font-semibold text-dg-mist mb-2">
              {g.title}
            </div>
            <ul className="space-y-0.5">
              {g.items.map((it) => (
                <li key={it.label}>
                  {it.to ? (
                    <NavLink
                      to={it.to}
                      end
                      className={({ isActive }) =>
                        clsx(
                          'block px-2 py-1.5 rounded-md text-sm transition',
                          isActive
                            ? 'bg-dg-red/15 text-white border-l-2 border-dg-red pl-[6px]'
                            : 'text-dg-text-2 hover:bg-white/5 hover:text-white'
                        )
                      }
                    >
                      {it.label}
                    </NavLink>
                  ) : (
                    <NavLink
                      to="/recruiting/coming-soon"
                      state={{ feature: it.label }}
                      className="block px-2 py-1.5 rounded-md text-sm text-dg-mist/70 hover:bg-white/5"
                    >
                      <span>{it.label}</span>
                      <span className="ml-2 text-[9px] uppercase tracking-wider text-dg-mist/60">
                        Soon
                      </span>
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
